import * as routes from '../../routes/deliveries.routes'
import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'

export async function fetchEnderecamentoEntregas(selectedTp) {
  try {
    const url = routes.urlGetEnderecamentoEntregas(selectedTp)
    const response = await authHttp().get(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function fetchEnderecamentoEntregasAnalitico(selectedTp) {
  try {
    const url = routes.urlGetEnderecamentoEntregasAnalitico(selectedTp)
    const response = await authHttp().get(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function apagarEnderecamentoDaEntrega(delivery_id, enderecamento) {
  try {
    const url = routes.urlApagarEnderecamentoDaEntrega(delivery_id, enderecamento)
    const response = await authHttp().delete(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function salvarEnderecamentoDaEntrega(delivery_id, endereco) {
  try {
    const url = routes.urlSalvarEnderecamentoDaEntrega()
    const response = await authHttp().post(url, { delivery_id, endereco })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
